// 消耗入库
import React from 'react'
import { connect } from 'react-redux'
import { getListItems, getFormValue, nullDate, TDate } from '../../public/utility'
import { getListIds, changeListItem, getListFromValues } from '../../public/utility'
import TreeSelect from '../../business/TreeSelect'

class ConsumablesWarehousingDiv extends React.Component {
    state = {
        changedValues基本信息: {}
    }

    componentDidMount = () => {
        this.handelGetAcceptance()
    }

    handelGetAcceptance = () => {
        const { list } = this.props
        Tyan.doPostEvent('GetWarehousingInfo', {
            data: { list },
            onEnd: ({ errorMessage, initValues基本信息, optionsParas }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                    return
                }
                else {
                    this.setState({ initValues基本信息, changedValues基本信息: {}, optionsParas })
                }
            }
        })
    }

    handlerAssignInspectors = () => {
        const { onSave, onClose } = this.props
        const { initValues基本信息, changedValues基本信息 } = this.state
        var newChangedValues = { ...initValues基本信息, ...changedValues基本信息 }
        var { 待入库明细 } = newChangedValues
        待入库明细.forEach(o => delete newChangedValues[`待入库明细[${o}].items`])
        delete newChangedValues['待入库明细']
        Tyan.doPostEvent('BatchWarehousing', {
            data: { changedValues基本信息: newChangedValues },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('操作成功')
                    onSave && onSave()
                    onClose && onClose()
                }
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    canSave = () => {
        const { list } = getListItems(this, '基本信息', '待入库明细')
        return list.filter(o => !o.入库数量 /* || !o.物品库存编号 */ || !o.分类 || o.入库数量 > o.待入库数量 || !o.生产单位 || !o.规格型号 || !o.有效日期 || o.有效日期 == nullDate || !o.存放位置|| !o.购买日期 || o.购买日期 == nullDate).length == 0
    }

    fieldset基本信息 = () => {
        const { list } = getListItems(this, '基本信息', '待入库明细')
        const p = { margin: '5px 15px 5px 15px', minWidth: 100, _full: true, flex: 1 }

        return list.map(o => ({
            _border: '', margin: '15 10 0 0', list: { listName: '待入库明细', id: o.id }, minWidth: '90%', items: [
                { _text: '物料名称', disabled: true, minWidth: '45%' },
                { _text: '物料代码', disabled: true, minWidth: '45%' },
                { _select: '分类', options: o.items, required: true, minWidth: '45%' },
                // { _text: '物品库存编号', required: true, minWidth: '45%' },
                // { _text: '标准物质名称', minWidth: '45%' },
                { _text: '生产单位', required: true, minWidth: '45%' },
                { _text: '规格/型号', name: '规格型号', required: true, minWidth: '45%' },
                // { _text: '规格', minWidth: '45%' },
                { _text: '试剂级别', required: true, minWidth: '45%' },
                { _text: '批号', required: true, minWidth: '45%' },
                { _float: '单价', required: true, minWidth: '45%' },
                { _date: '有效日期', required: true, minWidth: '45%' },
                { _text: '存放位置', required: true, minWidth: '45%' },
                { _int: '入库数量', required: true, maxValue: o.待入库数量, minWidth: '45%' },
                { _text: '单位', disabled: true, minWidth: '45%' },
                { _date: '购买日期', required: true, minWidth: '45%' },
            ]
        }))
    }

    render() {
        const { showBody: Body, showMessage: Message, } = this.props
        const { initValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />

        const canSave = this.canSave()
        return <Body data={this} maxWidth="1200"
            controls={
                [
                    { _button: '确定', icon: 'save', handler: this.handlerAssignInspectors, disabled: !canSave },
                    { _button: '关闭', icon: 'close', handler: this.handlerClose },
                ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
                ]}
        />
    }
}

export default connect()(ConsumablesWarehousingDiv)